import { render, staticRenderFns } from "./SelectCareTeam.vue?vue&type=template&id=622b8da8&scoped=true"
import script from "./SelectCareTeam.vue?vue&type=script&lang=js"
export * from "./SelectCareTeam.vue?vue&type=script&lang=js"
import style0 from "./SelectCareTeam.vue?vue&type=style&index=0&id=622b8da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b8da8",
  null
  
)

export default component.exports